import React from 'react';
import styled from 'styled-components';
import images from '../../Theming/images';

const Logo = styled.img`
  height: 100%;
  width: 100%;
`;

const DominosLogo: React.FC<React.CSSProperties> = ({ ...rest }) => {
  return (
    <Logo
      id="dominos-logo"
      src={images.dominos_logo.default}
      alt="Dominos logo"
      style={{ ...rest }}
    />
  );
};

DominosLogo.defaultProps = {};
export default DominosLogo;
